import React from "react";
import { Route } from "react-router-dom";
import { connect } from "react-redux";
import Aux from "../containers/Aux";

const PublicRoutes = ({ component: Component, isAuthenticated, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props =>
        isAuthenticated ? (
          <Aux>
            <Component {...props} />
          </Aux>
        ) : (
          <Aux>
            <Component {...props} />
          </Aux>
        )
      }
    />
  );
};

// Retrieve data from store as props
function mapStateToProps(store) {
  return {
    isAuthenticated: store.auth.isAuthenticated,
    loading: store.auth.isLoading
  };
}

export default connect(mapStateToProps)(PublicRoutes);



// WEBPACK FOOTER //
// ./src/system/routes/Public.jsx